<template>
  <div
    id="breadcrumbs-container"
    :class="[$route.meta.pageType === 'test' ? 'doing-test' : '']"
  >
    <ul>
      <li v-for="(crumb, index) in crumbs" :key="index">
        <router-link v-if="crumb.title && crumb.link" :to="crumb.link">{{
          crumb.title
        }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TheBreadCrumbs",
  computed: {
    crumbs() {
      let result = [];
      if (this.breadcrumbs) {
        if (this.breadcrumbs.length >= 1) {
          result.push(this.breadcrumbs[0]);
        }
        if (this.breadcrumbs.length > 1) {
          result.push(this.breadcrumbs[this.breadcrumbs.length - 1]);
        }
      }
      return result;
    },
    ...mapGetters(["breadcrumbs"]),
  },
};
</script>

<style lang="scss" scoped>
#breadcrumbs-container {
  background: $blue;
  color: #ffffff;
  padding: 8px;
  min-height: 30px;
  width: 100%;
  border-top: 5px solid #fff;

  &.doing-test {
    border-top: none;
    padding-left: 55px;
    padding-top: 10px;
  }

  ul {
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    li {
      display: inline-block;
      margin-right: 3px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #ffffff;

      &:before {
        padding: 0 2px;
      }
      &:first-child:before {
        content: "";
      }
      a {
        color: #ffffff;
        transition: color 0.2s ease-in-out;
        &:hover {
          color: $green;
        }
      }

      &:first-child {
        flex-shrink: 0;
      }
      &:last-child {
        flex-grow: 1;
        flex-shrink: 0;
      }
    }
  }
}
</style>
